var React = require('react');

function Ethereum (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"style":{"fill":"#8A92B2"},"points":"15,3.14 7.72,15.22 15,11.91 \t","key":0}),React.createElement("polygon",{"style":{"fill":"#62688F"},"points":"15,11.91 7.72,15.22 15,19.52 \t","key":1}),React.createElement("polygon",{"style":{"fill":"#62688F"},"points":"22.28,15.22 15,3.14 15,11.91 \t","key":2}),React.createElement("polygon",{"style":{"fill":"#454A75"},"points":"15,19.52 22.28,15.22 15,11.91 \t","key":3}),React.createElement("polygon",{"style":{"fill":"#8A92B2"},"points":"7.72,16.6 15,26.86 15,20.9 \t","key":4}),React.createElement("polygon",{"style":{"fill":"#62688F"},"points":"15,20.9 15,26.86 22.28,16.6 \t","key":5})]));
}

Ethereum.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 30 30","style":{"enableBackground":"new 0 0 30 30"},"xmlSpace":"preserve"};

module.exports = Ethereum;

Ethereum.default = Ethereum;
